// Quarter period utilities.
//
// A quarter period is stored as the ISO date of its first day:
//   Q1 = YYYY-01-01, Q2 = YYYY-04-01, Q3 = YYYY-07-01, Q4 = YYYY-10-01.
// All helpers operate on the ISO date string directly (no Date parsing) so
// they are timezone-safe.

/** Quarter index (1-4) for a given ISO date string. */
export function quarterOf(period: string): number {
  const month = parseInt(period.slice(5, 7), 10) // 1-12
  return Math.floor((month - 1) / 3) + 1
}

/** Year of an ISO date string. */
export function yearOf(period: string): number {
  return parseInt(period.slice(0, 4), 10)
}

/** First day of a quarter as an ISO date string, e.g. quarterStart(2026, 2) -> '2026-04-01'. */
export function quarterStart(year: number, quarter: number): string {
  const month = (quarter - 1) * 3 + 1
  return `${year}-${String(month).padStart(2, '0')}-01`
}

/** Human label for a quarter period, e.g. 'Q2 2026'. */
export function formatQuarterLabel(period: string): string {
  if (!period) return ''
  return `Q${quarterOf(period)} ${yearOf(period)}`
}
